export const styles = {
  container: (theme) => ({
    borderBottom: '1px solid',
    borderColor: theme.palette.grey.L80,

    '& .MuiContainer-root': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
    },
  }),
};
